import { Footer, Header } from 'components'
import React, { useEffect } from 'react'

import { Custom03 as Custom03Container } from 'containers'
import { helmet } from 'utils'
import styles from './Custom_03.module.scss'

const SEO_Data = helmet({
  title: 'Karriere',
  description: 'Ihre Karriere bei uns'
})

const Custom03 = () => {

  useEffect(() => {
    window.scroll(0,0)
  });

  return (
    <div>
      {/* Insert Helmet Data */}
      {SEO_Data}

      {/* Render Screen */}
      <Header />
      <article className={styles.content}>
        <Custom03Container />
      </article>
      <Footer />
    </div>
  )
}

export { Custom03 as default }